(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      root.querySelectorAll('[data-sym-carousel]').forEach((section) => {
        if (section.dataset.carouselReady) return;
        section.dataset.carouselReady = 'true';
        const track = section.querySelector('[data-carousel-track]');
        const controls = section.querySelector('[data-carousel-controls]');
        const previous = section.querySelector('[data-carousel-previous]');
        const next = section.querySelector('[data-carousel-next]');
        if (!track || !controls || !previous || !next) return;
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          controls.hidden = maximum < 2;
          previous.disabled = track.scrollLeft < 2;
          next.disabled = track.scrollLeft >= maximum - 2;
        };
        const move = (direction) => {
          const card = track.querySelector('.grid-product');
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '0') : track.clientWidth;
          track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive: true});
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        new ResizeObserver(update).observe(track);
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
    else initialise(document);
    document.addEventListener('shopify:section:load', () => initialise(document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symphonia-concert-booking-first"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-booking-section]').forEach((section) => {
    if (section.dataset.bookingReady === 'true') return;
    section.dataset.bookingReady = 'true';

    const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const variantInput = section.querySelector('[data-variant-id]');
    const quantityInput = section.querySelector('[data-quantity]');
    const total = section.querySelector('[data-total]');
    const submit = section.querySelector('[data-add-to-cart]');
    const submitText = section.querySelector('[data-add-to-cart-text]');
    const concertTitle = section.querySelector('[data-concert-title]');
    const concertDate = section.querySelector('[data-concert-date]');
    const dateSuffix = section.dataset.dateSuffix;
    const currency = section.dataset.currency;
    const addLabel = submit.dataset.addLabel || 'Add to cart';
    const soldOutLabel = submit.dataset.soldOutLabel || 'Sold out';

    const money = (cents) =>
      new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      }).format(cents / 100);

    const selectedValue = (selector) => section.querySelector(`${selector}:checked`)?.value;

    const matchingVariant = (concert, ticket) =>
      variants.find((variant) => variant.options[0] === concert && variant.options[1] === ticket);

    const updateTicketPrices = (concert) => {
      section.querySelectorAll('[data-ticket-price]').forEach((price) => {
        const variant = matchingVariant(concert, price.dataset.ticketPrice);
        price.textContent = variant ? money(variant.price) : '';
      });
    };

    const update = () => {
      const concert = selectedValue('[data-concert-option]');
      const ticket = selectedValue('[data-ticket-option]');
      const variant = matchingVariant(concert, ticket);
      if (!variant) return;

      const divider = concert.indexOf(' - ');
      const date = divider === -1 ? '' : concert.slice(0, divider);
      const title = divider === -1 ? concert : concert.slice(divider + 3);
      const quantity = Math.max(1, Number(quantityInput.value) || 1);

      variantInput.value = variant.id;
      quantityInput.value = quantity;
      concertTitle.textContent = title;
      concertDate.textContent = `${date} ${dateSuffix}`.trim();
      total.textContent = money(variant.price * quantity);
      submit.disabled = !variant.available;
      submitText.textContent = variant.available ? addLabel : soldOutLabel;
      updateTicketPrices(concert);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      url.hash = 'book-tickets';
      window.history.replaceState({}, '', url);
    };

    section.querySelectorAll('[data-ticket-option], [data-concert-option]').forEach((input) => {
      input.addEventListener('change', () => {
        update();
        if (input.matches('[data-concert-option]')) {
          input.closest('details').open = false;
        }
      });
    });

    section.querySelector('[data-quantity-minus]').addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value) - 1);
      update();
    });

    section.querySelector('[data-quantity-plus]').addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value) + 1);
      update();
    });

    quantityInput.addEventListener('change', update);

    section.querySelectorAll('.symphonia-booking-first__description a[href*="#ticket-selection-anchor"]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.hash = 'book-tickets';
      link.href = url.toString();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symphonia-on-stage-registration"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sym-onstage[data-section-id]').forEach((section) => {
    const paths = section.querySelectorAll('[data-onstage-path]');
    const form = section.querySelector('.sym-onstage__form');
    const variant = form.querySelector('[data-onstage-variant]');
    const title = form.querySelector('[data-onstage-title]');
    const price = form.querySelector('[data-onstage-price]');
    const total = form.querySelector('[data-onstage-total]');
    const submit = form.querySelector('[data-onstage-submit]');
    const pathProperty = form.querySelector('[data-onstage-path-property]');
    const included = form.querySelector('[data-onstage-included]');
    const casual = form.querySelector('[data-onstage-casual]');
    const gold = form.querySelector('[data-onstage-gold]');
    const goldNote = form.querySelector('[data-onstage-gold-note]');
    const pieces = Array.from(form.querySelectorAll('[data-onstage-piece]'));
    const addPiece = form.querySelector('[data-onstage-add-piece]');
    const removePiece = form.querySelector('[data-onstage-remove-piece]');
    const bridgeUrl = section.dataset.onstageBridgeUrl;
    const bridgeFrame = form.querySelector('[data-onstage-bridge-frame]');
    const status = form.querySelector('[data-onstage-status]');
    const registrationIdInput = form.querySelector('[data-onstage-registration-id]');
    let pendingRegistrationId = '';
    let pendingResponseToken = '';
    let responseTimer = 0;

    const labels = {
      included: {
        title: section.querySelector('[value="student"]').closest('label').querySelector('strong').textContent,
        submit: 'Submit registration'
      },
      student: {
        title: section.querySelector('[value="student"]').closest('label').querySelector('strong').textContent,
        submit: 'Submit registration'
      },
      member: {
        title: section.querySelector('[value="member"]').closest('label').querySelector('strong').textContent,
        submit: 'Submit registration'
      },
      casual: {
        title: section.querySelector('[value="casual"]').closest('label').querySelector('strong').textContent,
        submit: 'Continue to checkout'
      },
      gold: {
        title: section.querySelector('[value="gold"]').closest('label').querySelector('strong').textContent,
        submit: gold.dataset.submitLabel
      }
    };

    const updateVariant = (input) => {
      variant.value = input.dataset.variantId;
      price.textContent = input.dataset.price;
      total.textContent = input.dataset.price;
    };

    paths.forEach((input) => {
      input.addEventListener('change', () => {
        section.querySelectorAll('.sym-onstage__paths>label').forEach((label) => label.classList.remove('is-selected'));
        input.closest('label').classList.add('is-selected');
        included.hidden = input.value !== 'student' && input.value !== 'member';
        casual.hidden = input.value !== 'casual';
        gold.hidden = input.value !== 'gold';
        goldNote.hidden = input.value !== 'gold';
        title.textContent = labels[input.value].title;
        submit.textContent = labels[input.value].submit;
        pathProperty.value = labels[input.value].title;
        const selectedSuboption = form.querySelector(`[data-onstage-${input.value}] [data-onstage-suboption]:checked`);
        updateVariant(selectedSuboption || input);
      });
    });

    form.querySelectorAll('[data-onstage-suboption]').forEach((input) => {
      input.addEventListener('change', () => updateVariant(input));
    });

    const createRegistrationId = (dateIso) => {
      const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      const values = new Uint8Array(8);
      window.crypto.getRandomValues(values);
      const suffix = Array.from(values, (value) => alphabet[value % alphabet.length]).join('');
      return `OS-${dateIso.replaceAll('-', '')}-${suffix}`;
    };

    const createResponseToken = () => {
      const values = new Uint8Array(32);
      window.crypto.getRandomValues(values);
      return Array.from(values, (value) => value.toString(16).padStart(2, '0')).join('');
    };

    const bridgePayload = () => {
      const concert = form.querySelector('[data-onstage-concert]');
      const selectedConcert = concert.options[concert.selectedIndex];
      const payload = {
        website: form.querySelector('[data-onstage-website]').value,
        registration_id: pendingRegistrationId,
        response_token: pendingResponseToken,
        registration_type: pathProperty.value,
        concert_date: concert.value,
        concert_date_iso: selectedConcert.dataset.dateIso,
        performer_name: form.querySelector('[data-onstage-performer]').value,
        email: form.querySelector('[data-onstage-email]').value,
        instrument: form.querySelector('[data-onstage-instrument]').value,
        teacher: form.querySelector('[data-onstage-teacher]').value,
        grade: form.querySelector('[data-onstage-grade]').value,
        total_length: form.querySelector('[data-onstage-total-length]').value,
        accompanist: form.querySelector('[data-onstage-accompanist]').value,
        notes: form.querySelector('[data-onstage-notes]').value
      };

      form.querySelectorAll('[data-onstage-piece-input]').forEach((input, index) => {
        payload[`piece_${index + 1}`] = input.disabled ? '' : input.value;
      });

      return payload;
    };

    const postToBridge = (payload) => {
      const bridgeForm = document.createElement('form');
      bridgeForm.action = bridgeUrl;
      bridgeForm.method = 'post';
      bridgeForm.target = bridgeFrame.name;

      Object.entries(payload).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.name = name;
        input.type = 'hidden';
        input.value = value;
        bridgeForm.appendChild(input);
      });

      document.body.appendChild(bridgeForm);
      bridgeForm.submit();
      bridgeForm.remove();
    };

    const isTrustedBridgeOrigin = (origin) => {
      try {
        const parsed = new URL(origin);
        return parsed.protocol === 'https:' && (
          parsed.hostname === 'script.google.com' ||
          parsed.hostname === 'script.googleusercontent.com' ||
          parsed.hostname.endsWith('-script.googleusercontent.com')
        );
      } catch (error) {
        return false;
      }
    };

    window.addEventListener('message', (event) => {
      const result = event.data;

      if (
        !isTrustedBridgeOrigin(event.origin) ||
        !result ||
        result.source !== 'symphonia-onstage' ||
        result.registrationId !== pendingRegistrationId ||
        result.responseToken !== pendingResponseToken
      ) {
        return;
      }

      window.clearTimeout(responseTimer);

      if (result.status === 'ok' || result.status === 'duplicate') {
        const selectedPath = form.querySelector('[data-onstage-path]:checked').value;

        if (selectedPath === 'student' || selectedPath === 'member') {
          status.textContent = status.dataset.successLabel;
          status.hidden = false;
          submit.disabled = true;
          return;
        }

        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      status.textContent = status.dataset.errorLabel;
      status.hidden = false;
      submit.disabled = true;
    });

    form.addEventListener('submit', (event) => {
      if (!bridgeUrl) {
        return;
      }

      event.preventDefault();

      if (pendingRegistrationId) {
        return;
      }

      const concert = form.querySelector('[data-onstage-concert]');
      const selectedConcert = concert.options[concert.selectedIndex];
      pendingRegistrationId = createRegistrationId(selectedConcert.dataset.dateIso);
      pendingResponseToken = createResponseToken();
      registrationIdInput.value = pendingRegistrationId;
      submit.disabled = true;
      status.textContent = status.dataset.workingLabel;
      status.hidden = false;
      postToBridge(bridgePayload());
      responseTimer = window.setTimeout(() => {
        status.textContent = status.dataset.errorLabel;
        status.hidden = false;
        submit.disabled = true;
      }, 20000);
    });

    const updatePieceControls = () => {
      const visiblePieces = pieces.filter((piece) => !piece.hidden);
      addPiece.hidden = visiblePieces.length >= pieces.length;
      removePiece.hidden = visiblePieces.length <= 1;
    };

    addPiece.addEventListener('click', () => {
      const nextPiece = pieces.find((piece) => piece.hidden);
      if (!nextPiece) return;
      const input = nextPiece.querySelector('input');
      nextPiece.hidden = false;
      input.disabled = false;
      input.required = true;
      updatePieceControls();
    });

    removePiece.addEventListener('click', () => {
      const visiblePieces = pieces.filter((piece) => !piece.hidden);
      if (visiblePieces.length <= 1) return;
      const lastPiece = visiblePieces[visiblePieces.length - 1];
      const input = lastPiece.querySelector('input');
      input.value = '';
      input.required = false;
      input.disabled = true;
      lastPiece.hidden = true;
      updatePieceControls();
    });

    updatePieceControls();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symphonia-onstage-google-form-payment"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-onstage-form-payment]').forEach((section) => {
    if (section.dataset.initialised === 'true') return;
    section.dataset.initialised = 'true';

    const form = section.querySelector('[data-onstage-checkout-form]');
    const options = Array.from(form.querySelectorAll('input[type="radio"]'));
    const variantInput = form.querySelector('[data-onstage-checkout-variant]');
    const button = form.querySelector('[data-onstage-checkout-button]');
    const price = form.querySelector('[data-onstage-payment-price]');
    const note = form.querySelector('[data-onstage-payment-note]');

    const update = () => {
      const selected = options.find((option) => option.checked);
      section.querySelectorAll('.onstage-form-payment__option').forEach((label) => {
        label.classList.toggle('is-selected', label.contains(selected));
      });

      if (!selected || selected.dataset.kind === 'included') {
        variantInput.value = '';
        price.textContent = 'NZ$0';
        note.textContent = 'No checkout required after submitting the form.';
        button.textContent = 'No payment required';
        button.disabled = true;
        return;
      }

      variantInput.value = selected.dataset.variantId;
      price.textContent = selected.closest('label').querySelector('b').textContent;
      note.textContent = 'You will continue to secure Shopify checkout.';
      button.textContent = 'Continue to checkout';
      button.disabled = false;
    };

    options.forEach((option) => option.addEventListener('change', update));
    form.addEventListener('submit', (event) => {
      if (!variantInput.value) event.preventDefault();
    });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symphonia-retail-product"]) return;
  try {
    
  document.querySelectorAll('[data-retail-product]').forEach((section) => {
    if (section.dataset.initialised === 'true') return;
    section.dataset.initialised = 'true';

    const variantData = section.querySelector('[data-retail-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const optionButtons = Array.from(section.querySelectorAll('[data-option-index]'));
    const optionGroups = Array.from(section.querySelectorAll('[data-retail-option]'));
    const price = section.querySelector('[data-retail-price]');
    const comparePrice = section.querySelector('[data-retail-compare-price]');
    const availability = section.querySelector('[data-retail-availability]');
    const variantId = section.querySelector('[data-retail-variant-id]');
    const submit = section.querySelector('[data-retail-submit]');
    const quantity = section.querySelector('[data-retail-quantity]');
    const description = section.querySelector('[data-retail-description]');
    const moneyFormat = section.dataset.moneyFormat || '$';

    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      const value = Number(number || 0).toFixed(precision);
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length === 1 ? parts[0] : parts[0] + decimal + parts[1];
    };

    const formatMoney = (cents) => {
      const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return moneyFormat + formatWithDelimiters(Number(cents) / 100);
      const formats = {
        amount: () => formatWithDelimiters(Number(cents) / 100, 2, ',', '.'),
        amount_no_decimals: () => formatWithDelimiters(Number(cents) / 100, 0, ',', '.'),
        amount_with_comma_separator: () => formatWithDelimiters(Number(cents) / 100, 2, '.', ','),
        amount_no_decimals_with_comma_separator: () => formatWithDelimiters(Number(cents) / 100, 0, '.', ','),
        amount_with_apostrophe_separator: () => formatWithDelimiters(Number(cents) / 100, 2, "'", '.')
      };
      const formatter = formats[match[1]] || formats.amount;
      return moneyFormat.replace(match[0], formatter());
    };

    let selections = optionGroups.map((group) => {
      const selected = group.querySelector('[aria-pressed="true"]');
      return selected ? selected.dataset.optionValue : '';
    });

    const exactVariant = (candidateSelections) => variants.find((variant) =>
      variant.options.every((option, index) => option === candidateSelections[index])
    );

    const candidateFor = (index, value) => {
      const candidateSelections = selections.slice();
      candidateSelections[index] = value;
      return exactVariant(candidateSelections) || variants.find((variant) => variant.options[index] === value);
    };

    const showMedia = (mediaId, imageId) => {
      const mediaItems = Array.from(section.querySelectorAll('[data-media-id]'));
      const selected = mediaItems.find((item) =>
        String(item.dataset.mediaId) === String(mediaId) ||
        (imageId && String(item.dataset.imageId) === String(imageId))
      );
      if (!selected) return;

      mediaItems.forEach((item) => {
        item.hidden = item !== selected;
      });

      section.querySelectorAll('[data-media-thumbnail]').forEach((thumbnail) => {
        thumbnail.setAttribute('aria-current', String(thumbnail.dataset.mediaThumbnail === selected.dataset.mediaId));
      });
    };

    const update = (variant) => {
      if (!variant) return;
      selections = variant.options.slice();

      optionGroups.forEach((group, index) => {
        const current = group.querySelector('[data-option-current]');
        if (current) current.textContent = selections[index] || '';
      });

      optionButtons.forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const isSelected = selections[index] === button.dataset.optionValue;
        const candidate = candidateFor(index, button.dataset.optionValue);
        const optionPrice = button.querySelector('[data-option-price]');
        button.setAttribute('aria-pressed', String(isSelected));
        button.classList.toggle('is-unavailable', !candidate || !candidate.available);
        if (optionPrice && candidate) optionPrice.textContent = formatMoney(candidate.price);
      });

      price.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
        comparePrice.textContent = formatMoney(variant.compare_at_price);
        comparePrice.hidden = false;
      } else {
        comparePrice.textContent = '';
        comparePrice.hidden = true;
      }

      availability.textContent = variant.available ? section.dataset.labelAvailable : section.dataset.labelSoldOut;
      availability.dataset.available = String(Boolean(variant.available));
      variantId.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? section.dataset.labelAdd : section.dataset.labelSoldOut;

      const featuredMedia = variant.featured_media || {};
      const featuredImage = variant.featured_image || {};
      showMedia(featuredMedia.id, featuredImage.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.optionIndex);
        const candidateSelections = selections.slice();
        candidateSelections[index] = button.dataset.optionValue;
        let variant = exactVariant(candidateSelections);
        if (!variant) variant = candidateFor(index, button.dataset.optionValue);
        update(variant);
      });
    });

    section.querySelectorAll('[data-media-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaThumbnail, ''));
    });

    section.querySelector('[data-quantity-decrease]').addEventListener('click', () => {
      const value = Math.max(1, Math.floor(Number(quantity.value) || 1));
      quantity.value = String(Math.max(1, value - 1));
    });

    section.querySelector('[data-quantity-increase]').addEventListener('click', () => {
      const value = Math.max(1, Math.floor(Number(quantity.value) || 1));
      quantity.value = String(value + 1);
    });

    quantity.addEventListener('change', () => {
      quantity.value = String(Math.max(1, Math.floor(Number(quantity.value) || 1)));
    });

    if (description) {
      description.querySelectorAll('style').forEach((style) => style.remove());
      description.querySelectorAll('h1').forEach((heading) => {
        const replacement = document.createElement('h2');
        replacement.className = heading.className;
        replacement.innerHTML = heading.innerHTML;
        heading.replaceWith(replacement);
      });
      description.querySelectorAll('tr').forEach((row) => {
        const firstCell = row.querySelector('th, td');
        if (firstCell && /^(supplier\s+)?sku$/i.test(firstCell.textContent.trim())) row.remove();
      });
      description.querySelectorAll('p, li').forEach((item) => {
        if (/^(supplier\s+)?sku\s*:/i.test(item.textContent.trim())) item.remove();
      });
    }

    const initial = variants.find((variant) => String(variant.id) === String(variantId.value)) || variants[0];
    update(initial);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symphonia-string-family-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-string-family]').forEach(async (section) => {
    if (section.dataset.multiInitialised === 'true') return;
    section.dataset.multiInitialised = 'true';
    if (section.querySelector('[data-packed-review]') && !window.SymPackedFamily87) {
      const asset = section.querySelector('script[src*="sym-packed-family87.js"]');
      if (asset) await new Promise((resolve) => {
        asset.addEventListener('load', resolve, {once:true});
        asset.addEventListener('error', resolve, {once:true});
        setTimeout(resolve, 10000);
      });
    }


    const mediaItems = Array.from(section.querySelectorAll('[data-media-id]'));
    const mediaThumbnails = Array.from(section.querySelectorAll('[data-media-thumbnail]'));

    const showMedia = (mediaId) => {
      const selected = mediaItems.find((item) =>
        String(item.dataset.mediaId) === String(mediaId)
      );
      if (!selected) return;

      mediaItems.forEach((item) => {
        item.hidden = item !== selected;
      });

      mediaThumbnails.forEach((thumbnail) => {
        thumbnail.setAttribute(
          'aria-current',
          String(thumbnail.dataset.mediaThumbnail === selected.dataset.mediaId)
        );
      });
    };

    mediaThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaThumbnail));
    });

    const form = section.querySelector('[data-multi-product-form]');
    const options = section.querySelector('.string-family__options');
    const originalRows = Array.from(section.querySelectorAll('[data-item]'));
    const originalIndex = new Map(originalRows.map((row, index) => [row, index]));
    const originalSingleRows = originalRows.filter((row) => row.dataset.itemKind === 'single');
    const originalBundleRows = originalRows.filter((row) => row.dataset.itemKind === 'bundle');
    const singleByVariantId = new Map(originalSingleRows.map((row) => [row.dataset.variantId, row]));
    const count = section.querySelector('[data-item-count]');
    const total = section.querySelector('[data-total-price]');
    const submit = section.querySelector('.string-family__submit');
    const error = section.querySelector('[data-cart-error]');
    const stockMessage = section.querySelector('[data-stock-message]');
    const setConversion = section.querySelector('[data-set-conversion]');
    const currency = form.dataset.currency || 'NZD';
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
      style: 'currency',
      currency
    });

    const componentIdsFor = (row) =>
      (row.dataset.componentVariantIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

    const normaliseKey = (value) => String(value || '').trim().toLowerCase();
    let optionNames = [];
    try {
      optionNames = JSON.parse(form.dataset.optionNames || '[]');
    } catch (_parseError) {
      optionNames = [];
    }

    const optionProfileCache = new WeakMap();
    const beginsWithStringName = (value) =>
      /^([EADGC])(?:\b|\s|$)/.test(String(value || '').trim().toUpperCase());

    const optionProfileFor = (row) => {
      if (optionProfileCache.has(row)) return optionProfileCache.get(row);

      let values = [];
      try {
        values = JSON.parse(row.dataset.optionValues || '[]');
      } catch (_parseError) {
        values = [];
      }

      let rowOptionNames = optionNames;
      if (row.dataset.optionNames) {
        try {
          rowOptionNames = JSON.parse(row.dataset.optionNames);
        } catch (_parseError) {
          rowOptionNames = optionNames;
        }
      }

      const names = values.map((_, index) => rowOptionNames[index] || '');
      let sizeIndex = names.findIndex((name) => normaliseKey(name) === 'size');
      let size = sizeIndex >= 0 ? values[sizeIndex] : '';

      if (!size) {
        const implicitSizeIndex = names.findIndex(
          (name, index) =>
            /(?:\d+\s*\/\s*\d+|full\s*size|\bviolin\b|\bviola\b|\bcello\b)/i.test(name) &&
            beginsWithStringName(values[index])
        );
        if (implicitSizeIndex >= 0) size = names[implicitSizeIndex];
      }

      let stringIndex = -1;
      let stringIndexScore = -1;

      values.forEach((value, index) => {
        if (!beginsWithStringName(value)) return;
        const optionName = normaliseKey(names[index]);
        const score = optionName === 'string' ? 3 : optionName === 'type' ? 2 : 1;
        if (score >= stringIndexScore) {
          stringIndex = index;
          stringIndexScore = score;
        }
      });

      const group = values
        .filter(
          (value, index) =>
            index !== sizeIndex &&
            index !== stringIndex &&
            normaliseKey(value) !== 'default title'
        )
        .join(' / ');
      const profile = {
        group,
        size,
        type: stringIndex >= 0 ? values[stringIndex] : ''
      };

      optionProfileCache.set(row, profile);
      return profile;
    };

    const sizeRanks = new Map();
    const groupRanks = new Map();

    originalSingleRows.forEach((row) => {
      const profile = optionProfileFor(row);
      const size = normaliseKey(profile.size);
      const group = normaliseKey(profile.group);
      const groupKey = `${size}\u0000${group}`;

      if (!sizeRanks.has(size)) sizeRanks.set(size, sizeRanks.size);
      if (!groupRanks.has(groupKey)) groupRanks.set(groupKey, groupRanks.size);
    });

    const stringRankFor = (row) => {
      const match = String(optionProfileFor(row).type || '').trim().toUpperCase().match(/^([EADGC])(?:\b|\s|$)/);
      if (!match) return 99;
      return { E: 0, A: 1, D: 2, G: 3, C: 4 }[match[1]];
    };

    const singleSortKey = (row) => {
      const profile = optionProfileFor(row);
      const size = normaliseKey(profile.size);
      const group = normaliseKey(profile.group);
      return [
        sizeRanks.get(size) ?? Number.MAX_SAFE_INTEGER,
        groupRanks.get(`${size}\u0000${group}`) ?? Number.MAX_SAFE_INTEGER,
        1,
        stringRankFor(row),
        originalIndex.get(row)
      ];
    };

    const compareSortKeys = (left, right) => {
      for (let index = 0; index < Math.max(left.length, right.length); index += 1) {
        const difference = (left[index] ?? 0) - (right[index] ?? 0);
        if (difference !== 0) return difference;
      }
      return 0;
    };

    const bundleSortKey = (row) => {
      const componentIds = componentIdsFor(row);
      const componentRows = componentIds.map((id) => singleByVariantId.get(id)).filter(Boolean);

      if (componentRows.length === 0) {
        return [
          Number.MAX_SAFE_INTEGER,
          Number.MAX_SAFE_INTEGER,
          0,
          0,
          originalIndex.get(row)
        ];
      }

      const anchorGroups = new Map();
      componentRows.forEach((componentRow) => {
        const componentKey = singleSortKey(componentRow);
        const anchorKey = `${componentKey[0]}\u0000${componentKey[1]}`;
        const existing = anchorGroups.get(anchorKey);
        anchorGroups.set(anchorKey, {
          count: (existing?.count || 0) + 1,
          key: existing?.key || componentKey
        });
      });

      const anchor = Array.from(anchorGroups.values()).sort(
        (left, right) => right.count - left.count || compareSortKeys(left.key, right.key)
      )[0].key;

      return [anchor[0], anchor[1], 0, 0, originalIndex.get(row)];
    };

    const rows = [...originalRows].sort((left, right) => {
      const leftKey = left.dataset.itemKind === 'bundle' ? bundleSortKey(left) : singleSortKey(left);
      const rightKey = right.dataset.itemKind === 'bundle' ? bundleSortKey(right) : singleSortKey(right);
      return compareSortKeys(leftKey, rightKey);
    });

    options.append(...rows);

    const singleRows = rows.filter((row) => row.dataset.itemKind === 'single');
    const bundleRows = rows.filter((row) => row.dataset.itemKind === 'bundle');

    const normaliseQuantity = (input) => {
      const value = Math.max(0, Math.floor(Number(input.value) || 0));
      input.value = String(value);
      return value;
    };

    const quantityFor = (row) => normaliseQuantity(row.querySelector('[data-item-quantity]'));
    const packedReview = form.hasAttribute('data-packed-review');
    const packedController = packedReview && window.SymPackedFamily87
      ? window.SymPackedFamily87.createController(form, rows, componentIdsFor) : null;


    const baseMaximumFor = (row) => {
      if (!row || row.dataset.maxQuantity === undefined) return Number.POSITIVE_INFINITY;
      return Math.max(0, Number(row.dataset.maxQuantity) || 0);
    };

    const maximumFor = (row) => {
      if (packedController) return packedController.maximum(row);
      let maximum = baseMaximumFor(row);

      if (row.dataset.itemKind === 'bundle') {
        componentIdsFor(row).forEach((componentId) => {
          const componentRow = singleByVariantId.get(componentId);
          if (!componentRow) return;

          const componentMaximum = baseMaximumFor(componentRow);
          if (!Number.isFinite(componentMaximum)) return;

          const usedByOtherBundles = bundleRows.reduce((quantity, bundleRow) => {
            if (bundleRow === row || !componentIdsFor(bundleRow).includes(componentId)) return quantity;
            return quantity + quantityFor(bundleRow);
          }, 0);

          const componentRemaining =
            componentMaximum - quantityFor(componentRow) - usedByOtherBundles;
          maximum = Math.min(maximum, Math.max(0, componentRemaining));
        });
      } else if (Number.isFinite(maximum)) {
        const selectedBundleQuantity = bundleRows.reduce((quantity, bundleRow) => {
          if (!componentIdsFor(bundleRow).includes(row.dataset.variantId)) return quantity;
          return quantity + quantityFor(bundleRow);
        }, 0);
        maximum = Math.max(0, maximum - selectedBundleQuantity);
      }

      return maximum;
    };

    const buildCartPlan = () => {
      if (packedController) return packedController.cartPlan();
      const quantities = new Map();
      rows.forEach((row) => {
        const input = row.querySelector('[data-item-quantity]');
        quantities.set(row.dataset.variantId, input.disabled ? 0 : quantityFor(row));
      });

      let convertedSets = 0;
      // Prefer the most complete verified combination before a smaller overlapping set.
      const candidates = [...bundleRows].sort((a, b) =>
        componentIdsFor(b).length - componentIdsFor(a).length ||
        Number(a.dataset.priceCents) - Number(b.dataset.priceCents)
      );
      candidates.forEach((row) => {
        if (row.querySelector('[data-item-quantity]').disabled) return;
        const componentIds = componentIdsFor(row);
        if (!componentIds.length || componentIds.some((id) => !singleByVariantId.has(id))) return;
        const required = new Map();
        componentIds.forEach((id) => required.set(id, (required.get(id) || 0) + 1));
        let matchingSets = Math.max(0, baseMaximumFor(row) - (quantities.get(row.dataset.variantId) || 0));
        let individualPrice = 0;
        required.forEach((quantity, id) => {
          matchingSets = Math.min(matchingSets, Math.floor((quantities.get(id) || 0) / quantity));
          individualPrice += quantity * Number(singleByVariantId.get(id).dataset.priceCents || 0);
        });
        if (matchingSets <= 0 || Number(row.dataset.priceCents) > individualPrice) return;
        required.forEach((quantity, id) => quantities.set(id, quantities.get(id) - matchingSets * quantity));
        quantities.set(row.dataset.variantId, (quantities.get(row.dataset.variantId) || 0) + matchingSets);
        convertedSets += matchingSets;
      });

      const items = [];
      let totalCents = 0;
      rows.forEach((row) => {
        const quantity = quantities.get(row.dataset.variantId) || 0;
        if (!quantity) return;
        items.push({ id: Number(row.dataset.variantId), quantity });
        totalCents += quantity * Number(row.dataset.priceCents || 0);
      });

      return { items, totalCents, convertedSets };
    };

    const showStockMessage = () => {
      stockMessage.textContent = form.dataset.labelMaximum;
      stockMessage.hidden = false;
    };

    const stockPilot = form.hasAttribute('data-stock-pilot');
    const stockRetry = form.querySelector('[data-stock-retry]');
    const quantityNote = form.querySelector('[data-stock-quantity-note]');
    let stockReady = !stockPilot;
    let stockRequest = null;
    const stockFingerprint = () => rows.map((row) => `${row.dataset.variantId}:${row.dataset.stockState}:${row.dataset.maxQuantity}`).join('|') + (packedController ? packedController.fingerprint() : '');
    const updateStockLabels = () => {
      if (!stockPilot) return;
      if (packedController) { packedController.updateStockLabels(); return; }
      const demand = new Map();
      rows.forEach((row) => {
        const ids = row.dataset.itemKind === 'bundle' ? componentIdsFor(row) : [row.dataset.variantId];
        ids.forEach((id) => demand.set(id, (demand.get(id) || 0) + quantityFor(row)));
      });
      let quantityUncertain = false;
      rows.forEach((row) => {
        const ids = row.dataset.itemKind === 'bundle' ? componentIdsFor(row) : [row.dataset.variantId];
        let state = row.dataset.stockState || 'unknown';
        if (state === 'local' && ids.some((id) => (demand.get(id) || 0) > 1)) {
          state = 'delivery';
          quantityUncertain = true;
        }
        const badge = row.querySelector('[data-stock-badge]');
        badge.dataset.state = state;
        badge.textContent = state === 'delivery' ? form.dataset.stockQuantityDelivery : form.dataset[`stock${state[0].toUpperCase()}${state.slice(1)}`];
      });
      quantityNote.hidden = !quantityUncertain;
    };
    const refreshStock = () => {
      if (!stockPilot) return Promise.resolve(true);
      if (stockRequest) return stockRequest;
      stockReady = false;
      options.disabled = true;
      submit.disabled = true;
      stockRequest = (packedController ? packedController.refreshNative() : Promise.all(rows.map(async (row) => {
        try {
          const url = new URL(row.dataset.stockUrl, window.location.origin);
          url.searchParams.set('variant', row.dataset.variantId);
          url.searchParams.set('section_id', packedReview ? 'sym-packed-family-stock' : 'sym-variant-stock-status');
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url.toString(), { cache: 'no-store', signal: AbortSignal.timeout(10000) });
          if (!response.ok) throw new Error('stock');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const record = documentFragment.querySelector(packedReview ? '[data-family-stock]' : '[data-current-stock]');
          if (!record || record.dataset.variantId !== row.dataset.variantId || !['true', 'false'].includes(record.dataset.local)) throw new Error('stock');
          if (packedReview && (record.dataset.eligible !== 'true' ||
            !Number.isSafeInteger(Number(record.dataset.maximum)) || Number(record.dataset.maximum) < 0 ||
            Number(record.dataset.price) !== Number(row.dataset.priceCents))) throw new Error('stock');
          row.dataset.maxQuantity = String(packedReview && record.dataset.available !== 'true' ? 0 : Math.max(0, Number(record.dataset.maximum) || 0));
          row.dataset.stockState = record.dataset.available !== 'true' ? 'out' : record.dataset.local === 'true' ? 'local' : 'online';
          const input = row.querySelector('[data-item-quantity]');
          input.disabled = row.dataset.stockState === 'out';
          return true;
        } catch (_error) {
          row.dataset.stockState = 'error';
          row.querySelector('[data-item-quantity]').disabled = true;
          return false;
        }
      }))).then(async (results) => {
        const packedReady = packedController ? await packedController.refresh() : !packedReview;
        stockReady = results.every(Boolean) && packedReady;
        stockRetry.hidden = stockReady;
        rows.forEach((row) => {
          const input = row.querySelector('[data-item-quantity]');
          input.value = String(input.disabled ? 0 : Math.min(quantityFor(row), maximumFor(row)));
        });
        options.disabled = false;
        update();
        return stockReady;
      }).catch(() => {
        stockReady = false;
        stockRetry.hidden = false;
        rows.forEach((row) => {
          row.dataset.stockState = 'error';
          row.querySelector('[data-item-quantity]').disabled = true;
        });
        options.disabled = false;
        update();
        return false;
      }).finally(() => { stockRequest = null; });
      return stockRequest;
    };

    const update = (keepStockMessage = false) => {
      let itemCount = 0;

      rows.forEach((row) => {
        const input = row.querySelector('[data-item-quantity]');
        const quantity = input.disabled ? 0 : normaliseQuantity(input);
        const maximum = maximumFor(row);
        const decrease = row.querySelector('[data-quantity-decrease]');
        const increase = row.querySelector('[data-quantity-increase]');

        if (Number.isFinite(maximum)) {
          input.max = String(maximum);
        } else {
          input.removeAttribute('max');
        }

        decrease.disabled = input.disabled || quantity === 0;
        if (stockPilot) increase.disabled = input.disabled;
        increase.classList.toggle('is-disabled', input.disabled || quantity >= maximum);
        increase.setAttribute('aria-disabled', String(input.disabled || quantity >= maximum));

        itemCount += quantity;
        row.classList.toggle('is-selected', quantity > 0);
      });

      const cartPlan = buildCartPlan();
      count.textContent = `${itemCount} ${itemCount === 1 ? form.dataset.labelItem : form.dataset.labelItems}`;
      total.textContent = formatter.format(cartPlan.totalCents / 100);
      setConversion.hidden = cartPlan.convertedSets === 0;
      updateStockLabels();
      submit.disabled = itemCount === 0 || !stockReady || !!cartPlan.error;
      submit.textContent = itemCount === 0 ? form.dataset.labelChoose : form.dataset.labelAdd;
      error.hidden = true;
      error.textContent = '';
      if (!keepStockMessage) {
        stockMessage.hidden = true;
        stockMessage.textContent = '';
      }
    };

    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-increase], [data-quantity-decrease]');
      if (!button || button.disabled) return;
      const row = button.closest('[data-item]');
      const input = row.querySelector('[data-item-quantity]');
      const change = button.hasAttribute('data-quantity-increase') ? 1 : -1;
      const current = normaliseQuantity(input);
      const maximum = maximumFor(row);

      if (change > 0 && current >= maximum) {
        showStockMessage();
        return;
      }

      const nextQuantity = Math.max(0, Math.min(maximum, current + change));
      input.value = String(nextQuantity);
      update(change > 0 && Number.isFinite(maximum) && nextQuantity >= maximum);
      if (change > 0 && Number.isFinite(maximum) && nextQuantity >= maximum) showStockMessage();
    });

    form.addEventListener('input', (event) => {
      if (!event.target.matches('[data-item-quantity]')) return;
      const row = event.target.closest('[data-item]');
      const requestedQuantity = normaliseQuantity(event.target);
      const maximum = maximumFor(row);
      const exceedsMaximum = requestedQuantity > maximum;

      if (exceedsMaximum) event.target.value = String(maximum);
      update(exceedsMaximum);
      if (exceedsMaximum) showStockMessage();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (stockPilot) {
        const before = stockFingerprint();
        const selectionBefore = JSON.stringify(buildCartPlan());
        const ready = await refreshStock();
        if (!ready || before !== stockFingerprint() || selectionBefore !== JSON.stringify(buildCartPlan())) {
          stockMessage.textContent = form.dataset.stockChanged;
          stockMessage.hidden = false;
          return;
        }
      }
      const checkedPlan = buildCartPlan();
      if (checkedPlan.error || (packedReview && !packedController)) {
        error.textContent = form.dataset.stockError;
        error.hidden = false;
        return;
      }
      const items = checkedPlan.items;

      if (items.length === 0) {
        update();
        return;
      }

      submit.disabled = true;
      submit.textContent = form.dataset.labelAdding;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || result.message || 'Unable to add the selected items.');
        }

        window.location.assign(`${window.Shopify.routes.root}cart`);
      } catch (caughtError) {
        error.textContent = caughtError.message;
        error.hidden = false;
        submit.disabled = false;
        submit.textContent = form.dataset.labelAdd;
      }
    });

    update();
    if (stockPilot) {
      refreshStock();
      stockRetry.addEventListener('click', refreshStock);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') refreshStock();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
